

import React from "react";
import { MasterConfigs } from "../../../../interfaces/entity";
import { Button, Typography } from "antd";
import MasterComponent from "../../../../components/Forms";
import { constants } from "../../../../constants/common";
import moment from "moment";
const { Title } = Typography;

const Meetings = ({ refId, highlighted, level }) => {

    const config: MasterConfigs = {
        api: () => `/booking-details?candidate=${refId}`,
        getColumns: () => [
            {
                title: 'Meeting Date',
                dataIndex: 'date',
                key: 'date',
                render: (text, record) => text + ' ' + record.time,
            },
            {
                title: 'Duration',
                dataIndex: 'durations',
                key: 'durations',
                render: (text, record) => text + ' mins',
            },
            {
                title: 'level',
                dataIndex: 'level',
                key: 'level',
                render: (text) => constants.PROFILE_STATUS_TEXT[text] || text,
            },
            {
                title: 'Scheduled By',
                dataIndex: 'createdBy',
                key: 'createdBy',
                render: (text) => text ? `${text.firstName} ${text.lastName}` : '',
            },
            {
                title: 'Updated By',
                dataIndex: 'updatedBy',
                key: 'updatedBy',
                render: (text) => text ? `${text.firstName} ${text.lastName}` : '',
            },
            {
                title: 'Created At',
                dataIndex: 'createdAt',
                key: 'createdAt',
                render: (text) => moment(text).format('lll'),
            },
            {
                title: 'Updated At',
                key: 'updatedAt',
                render: (text, record) => record.updatedAt ? moment(record.updatedAt).format('lll') : 'N/A',
            }
        ],
        isActionTab: false,
        actions: [],
    };

    return <>
        <div className="flex justify-between items-center py-2 px-4 border-b">
            <Title level={5} className={highlighted === 'invited-meetings' ? 'bg-yellow-200 px-1' : ''}>Invited Meetings</Title>
            <Button type="text" disabled>Schedule Meeting</Button>
        </div>
        <div className="p-4">
            <MasterComponent config={config} />
        </div>
    </>

}

export default Meetings;